import { Common } from '@thecvlb/design-system';

import { FlowTypes } from 'utils/enums';

import { DiscountBannerProps } from './discountBanner.types';

const DiscountBanner: React.FC<DiscountBannerProps> = ({ discount, flow, promoVisited }) => {
  return (
    <div
      className="flex h-7 flex-none items-center justify-center bg-secondary text-center text-base text-primary-700"
      data-testid="discount_banner"
    >
      <Common.Icon className="mr-2.5 size-4 text-white" name="tag-discount" />
      {['clearedcovered', 'cleared50', 'rex50'].includes(promoVisited) ? (
        <span>
          Exclusive{' '}
          <span className="mx-0.5 font-bold">{promoVisited === 'rex50' ? 'Rex' : 'Cleared'}</span>{' '}
          promo applied: You're saving <span className="mx-0.5 font-bold">{discount}</span>
        </span>
      ) : flow === FlowTypes.ShortFlow ? (
        <span>
          Get <span className="mx-0.5 font-bold">{discount} OFF </span>
          your first order
        </span>
      ) : promoVisited === 'freeccs' || promoVisited === 'freebct' ? (
        promoVisited === 'freeccs' ? (
          <span>
            <span className="mx-0.5 font-bold">{discount}: </span> AT-HOME COLON SCREENING
          </span>
        ) : (
          <span>
            <span className="mx-0.5 font-bold">{discount}: </span>
            AT-HOME BREAST CANCER DETECTION
          </span>
        )
      ) : (
        <span>
          Get <span className="mx-0.5 font-bold">{discount} OFF </span>
          with code <span className="font-bold">"{promoVisited.toUpperCase()}"</span>
        </span>
      )}
    </div>
  );
};

export default DiscountBanner;
